export default [
  {
    // 캠핑장/숙박시설
    path: 'camp',
    redirect: { name: 'CampMainRsvtStat' },
    children: [
      /** 예약현황 메인 */
      {
        path: 'main-rsvt-stat/list',
        name: 'CampMainRsvtStat',
        meta: { menu: 'camp', keepAlive: false },
        component: () => import('@/pages/resvMng/camp/mainRsvtStat/MainRsvtStatView.vue')
      },
      /** 시설분류 관리 */
      {
        path: 'fclty-category',
        redirect: { name: 'CampFcltyCategoryList' },
        children: [
            {
                path: 'list',
                name: 'CampFcltyCategoryList',
                meta: { menu: 'camp', keepAlive: true },
                component: () => import('@/pages/resvMng/camp/fcltyCategory/FcltyCategoryMngListView.vue')
            },
            {
                path: 'add',
                name: 'CampFcltyCategoryInsert',
                meta: { menu: 'camp', keepAlive: false },
                component: () => import('@/pages/resvMng/camp/fcltyCategory/FcltyCategoryMngInsertView.vue')
            },
            {
                path: 'modify/:ldgFcltClsfId',
                name: 'CampFcltyCategoryUpdate',
                meta: { menu: 'camp', keepAlive: false },
                component: () => import('@/pages/resvMng/camp/fcltyCategory/FcltyCategoryMngUpdateView.vue'),
                props: true
            }
        ]
      },
      {
        // 캠핑장 시설관리
        path: 'fclty',
        redirect: { name: 'CampFcltyMngList' },
        children: [
            {
                path: 'list',
                name: 'CampFcltyMngList',
                meta: { menu: 'camp', keepAlive: true },
                component: () => import('@/pages/resvMng/camp/fcltyMng/FcltyMngListView.vue')
            },
            {
                path: 'add',
                name: 'CampFcltyMngInsert',
                meta: { menu: 'camp', keepAlive: false },
                component: () => import('@/pages/resvMng/camp/fcltyMng/FcltyMngInsertView.vue')
            },
            {
                path: 'modify/:ldgFcltId',
                name: 'CampFcltyMngUpdate',
                meta: { menu: 'camp', keepAlive: false },
                component: () => import('@/pages/resvMng/camp/fcltyMng/FcltyMngUpdateView.vue'),
                props: true
            }
        ]
      },
      {
        // 캠핑장 예약현황
         path: 'rsvt',
        redirect: { name: 'CampRsvtList' },
        children: [
            {
                path: 'list',
                name: 'CampRsvtList',
                meta: { menu: 'camp', keepAlive: true },
                component: () => import('@/pages/resvMng/camp/rsvt/RsvtListView.vue')
            },
            {
                path: 'modify/:ldgFcltRsvtId',
                name: 'CampRsvtUpdate',
                meta: { menu: 'camp', keepAlive: false },
                component: () => import('@/pages/resvMng/camp/rsvt/RsvtUpdateView.vue'),
                props: true
            },
            {
                path: 'payment-history-popup',
                name: 'CampRsvtPaymentHistoryPopup',
                meta: { menu: 'camp', keepAlive: false, layout: 'blank' },
                component: () => import('@/pages/resvMng/common/popup/PaymentHistoryPopup.vue'),
                props: (route) => ({
                    rsvtType: 'camp',
                    rsvtNo: route.query.rsvtId || route.query.rsvtNo
                })
            }
        ]
      },
      {
        // 캠핑장 환불규정관리
        path:'rfnd-rule',
        redirect: { name: 'CampRfndRuleMng' },
        children: [
          {
            path: 'list',
            name: 'CampRfndRuleMng',
            meta: { menu: 'camp', keepAlive: false },
            component: () => import('@/pages/resvMng/camp/rfndRule/RfndRuleListView.vue'),
          },
        ]
      },
      {
        // 캠핑장 예약불가일관리
        path: 'rsvt-lmt',
        redirect: { name: 'CampRsvtLmtMng' },
        children: [
          {
            path: 'list',
            name: 'CampRsvtLmtMng',
            meta: { menu: 'camp', keepAlive: false },
            component: () => import('@/pages/resvMng/camp/rsvtLmt/RsvtLmtMngListView.vue')
          },
          {
            path: 'batch-popup',
            name: 'CampRsvtLmtBatchPopup',
            meta: { menu: 'camp', keepAlive: false, layout: 'popup' },
            component: () => import('@/pages/resvMng/camp/rsvtLmt/RsvtLmtMngBatchPopup.vue')
          }
        ]
      },

    ]
  }
]
